
export const getUniversalLinksStatus = async () => {

}